import { restApiClient } from '@/datasources';

export const REMOVE_COUPON_ROUTE = '/coupon/remove';

export async function removeCoupon(): Promise<void> {
  await restApiClient.delete(REMOVE_COUPON_ROUTE);
}
